import React from 'react';

var OverlayLabels = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-overlay-buttons' }, children);
};

export { OverlayLabels };
